"use strict";

$(document).ready(function () {
  if ($('body#prices-drop').length > 0) {
    selectCategoryInner();
  }

  prestashop.on('updateProductList', function () {
    selectCategoryInner();
  });
});

function selectCategoryInner() {
  $('.sort-by-row select').select2({
    minimumResultsForSearch: -1
  });
}